import { render, staticRenderFns } from "./IconSvgClock.vue?vue&type=template&id=cd06a99e&scoped=true&"
import script from "./IconSvgClock.vue?vue&type=script&lang=js&"
export * from "./IconSvgClock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd06a99e",
  null
  
)

export default component.exports